// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container_actions__nLwf4 {
  display: flex;
  justify-content: center;
}

.styles_container_content__okgTS {
  font-family: 'Inter';
  font-size: 1rem;
  font-weight: 500;
  max-width: 20rem;
  text-align: center;
  color: #18316E;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmDialog/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".container_actions {\n  display: flex;\n  justify-content: center;\n}\n\n.container_content {\n  font-family: 'Inter';\n  font-size: 1rem;\n  font-weight: 500;\n  max-width: 20rem;\n  text-align: center;\n  color: #18316E;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_actions": `styles_container_actions__nLwf4`,
	"container_content": `styles_container_content__okgTS`
};
export default ___CSS_LOADER_EXPORT___;
